<mat-dialog-content>
  <form>
    <h5 class="text-primary mb-3 text-center">Add Quantity</h5>

    <div class="col-lg-12">
      <label class="form-label">Quantity<span class="text-danger">*</span></label>
      <mat-form-field class="w-100">
        <input  matInput type="number" [(ngModel)]="quantity" name="quantity" [ngModelOptions]="{ standalone: true }" min="1" placeholder="Enter quantity" class="spinner-input" #qtyInput="ngModel" required/>
      </mat-form-field>
      <mat-error class="error-msg" *ngIf="qtyInput.errors?.['required']">
        Quantity is required.
      </mat-error>
      <mat-error class="error-msg" *ngIf="qtyInput.errors?.['min']">
        Quantity must be greater than 0.
      </mat-error>
    </div>
    <mat-dialog-actions class="dialog-actions gap-3 pt-4 p-0 d-flex flex-xl-nowrap flex-wrap justify-content-center">
      <button matButton="filled" type="button" class="btn dialog-btn-secondary" (click)="close()">Cancel</button>
      <button matButton="filled" type="button" class="btn dialog-btn-primary" (click)="confirmAdd()">Save</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
